import { Redirect, Route, useLocation } from 'react-router-dom';
import api from 'api/client';
import React, { useEffect, useState } from 'react';

const PublicRoute = ({ component: Component, ...rest }) => {
  // let token = api.getToken();
  const location = useLocation();
  const [token, setToken] = useState(api.getToken());

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    // const urlToken = queryParams.get('token');
    // const urlProduct = queryParams.get('product');
    const sipData = queryParams.get('sipdata');
    const manualSipData = queryParams.get('manualSipData');
    const corpVoucherCode = queryParams.get('voucherCode');
    const subscriptionId = queryParams.get('subscriptionSessionId');
    const encodedPayload = queryParams.get('payload');
    if (encodedPayload) {
      try {
        const payload = JSON.parse(decodeURIComponent(encodedPayload));
        if (payload.token) {
          localStorage.setItem('token', payload.token);
          setToken(payload.token);
          api.setToken(payload.token); // your custom API instance
        }
        if (payload.product) {
          localStorage.setItem('Product', payload.product); // Store token in localStorage
        }
      } catch (err) {
        console.error('Failed to parse payload', err);
      }
    }
    // if (urlToken) {
    //   localStorage.setItem('token', urlToken); /
    //   setToken(urlToken);
    //   api.setToken(urlToken);
    // }
    // if (urlProduct) {
    //   localStorage.setItem('Product', urlProduct); // Store token in localStorage
    // }
    if (sipData !== null) {
      try {
        const decodedSipData = decodeURIComponent(sipData);

        // Now, you can parse the decoded string into a JavaScript object
        const sipState = JSON.parse(decodedSipData);

        // Do something with sipState if needed
        localStorage.setItem('sipdata', decodedSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    } else if (manualSipData !== null) {
      try {
        const decodedmanualSipData = decodeURIComponent(manualSipData);

        // Now, you can parse the decoded string into a JavaScript object

        // Do something with sipState if needed
        localStorage.setItem('manualSipData', decodedmanualSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    }
    if (manualSipData !== null) {
      try {
        // const decodedSipData = decodeURIComponent(manualSipData);
        // Now, you can parse the decoded string into a JavaScript object
        // const sipState = JSON.parse(decodedSipData);

        // Do something with sipState if needed
        localStorage.setItem('manualSipData', manualSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    }
    if (corpVoucherCode) {
      localStorage.setItem('corpVoucherCode', corpVoucherCode);
      // isValidReferral(refCode, () => {});
    }
    if (subscriptionId) {
      localStorage.setItem('subscriptionId', subscriptionId);
    }
  }, [location.search]);
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        token ? <Redirect to='/dashboard' /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
